import React from 'react';

/**
 * SlowIcon — hand-drawn SVG glyphs for the four "coming slow" chapters.
 * Colours are inherited via `currentColor` so the icon adapts to card state.
 */
const paths = {
  // Olive branch — a small twig with two olives and three leaves.
  olive: (
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 30 C 12 24, 20 22, 28 20 C 36 18, 44 16, 50 12" />
      <path d="M14 27 C 10 22, 10 18, 14 15 C 18 18, 18 22, 14 27 Z" fill="currentColor" fillOpacity="0.14" />
      <path d="M26 22 C 22 17, 22 13, 26 10 C 30 13, 30 17, 26 22 Z" fill="currentColor" fillOpacity="0.14" />
      <path d="M38 18 C 34 13, 34 9, 38 6 C 42 9, 42 13, 38 18 Z" fill="currentColor" fillOpacity="0.14" />
      <ellipse cx="20" cy="30" rx="3" ry="4" fill="currentColor" fillOpacity="0.9" />
      <ellipse cx="32" cy="27" rx="3" ry="4" fill="currentColor" fillOpacity="0.9" />
    </g>
  ),
  // Wine glass — a slim silhouette with a subtle liquid line.
  glass: (
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8 L 38 8 C 40 22, 34 32, 28 33 C 22 32, 16 22, 18 8 Z" />
      <path d="M20 16 C 24 18, 32 18, 36 16" stroke="currentColor" strokeOpacity="0.55" />
      <path d="M28 33 L 28 46" />
      <path d="M20 48 L 36 48" />
    </g>
  ),
  // Sparkling bubble — a bubble with rising smaller bubbles.
  bubble: (
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="30" cy="34" r="12" />
      <circle cx="24" cy="30" r="1.5" fill="currentColor" fillOpacity="0.4" />
      <circle cx="34" cy="28" r="1.2" fill="currentColor" fillOpacity="0.5" />
      <circle cx="18" cy="18" r="2" />
      <circle cx="26" cy="10" r="1.4" />
      <circle cx="34" cy="14" r="1.7" />
      <circle cx="42" cy="8" r="1.2" />
    </g>
  ),
  // Honey — hexagonal comb cluster with a drop.
  honey: (
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 12 L 22 8 L 30 12 L 30 20 L 22 24 L 14 20 Z" />
      <path d="M30 12 L 38 8 L 46 12 L 46 20 L 38 24 L 30 20" />
      <path d="M22 24 L 30 28 L 30 36 L 22 40 L 14 36 L 14 28 Z" />
      <path d="M30 28 L 38 24 M 38 24 L 46 28 L 46 36 L 38 40 L 30 36" />
      <path d="M40 42 C 38 46, 40 50, 43 50 C 46 50, 48 46, 46 42 C 44 40, 42 40, 40 42 Z" fill="currentColor" fillOpacity="0.4" />
    </g>
  ),
};

export default function SlowIcon({ name, className = '', ...rest }) {
  return (
    <svg
      viewBox="0 0 60 54"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {paths[name] || paths.glass}
    </svg>
  );
}
